export enum LicenseTypeEnum {
    Commercial = 'Commercial',
    Testing = 'Testing',
    Distributor = 'Distributor',
    Developer = 'Developer',
    Modular = 'Modular',
}

export enum LicenseType {
    Commercial = 1,
    Testing,
    Distributor,
    Developer,
    Modular,
}

export const licenseTypeEnumTranslationsPl = {
    Commercial: 'Sprzedażowa',
    Testing: 'Testowa',
    Distributor: 'Dystrubutora',
    Developer: 'Deweloperska',
    Modular: 'Modułowa',
};

export const licenseTypeEnumTranslationsEn = {
    Commercial: 'Sale',
    Testing: 'Testing',
    Distributor: 'Distributor',
    Developer: 'Developer',
    Modular: 'Modular',
};

export const mapLicenseTypeToApiModel = (internalModel?: LicenseTypeEnum): LicenseType | undefined => {
    switch (internalModel) {
        case LicenseTypeEnum.Commercial:
            return LicenseType.Commercial;
        case LicenseTypeEnum.Developer:
            return LicenseType.Developer;
        case LicenseTypeEnum.Distributor:
            return LicenseType.Distributor;
        case LicenseTypeEnum.Testing:
            return LicenseType.Testing;
        case LicenseTypeEnum.Modular:
            return LicenseType.Modular;
        default:
            return undefined;
    }
};
